module.exports = __webpack_public_path__ + "img/fig09.e48b50f9.jpg";